<template>
  <div>
    <Toolbar class="p-mb-4">
      <template slot="left">
        <Button
          label="Add Enquiry Status"
          icon="pi pi-plus"
          class="p-button-success p-mr-2"
          @click="openNewTypesForm"
        />
      </template>
      <template slot="right">
        <span class="p-input-icon-left">
          <i class="pi pi-search" />
          <InputText v-model="filters['global']" placeholder="Global Search" />
        </span>
      </template>
    </Toolbar>
    <DataTable
      :value="opportunityStatuses"
      :paginator="true"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="25"
      dataKey="contactId"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[5, 10, 25]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Related Accounts"
    >
      <template #header>
        <div class="table-header">Related Opportunity Statuses</div>
      </template>

      <template #empty>
        No Related Opportunity Statuses. Accounts found!
      </template>
      <template #loading>
        Loading Related Opportunity Statuses. Please wait.
      </template>
      <Column field="id" header="Id" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.id ? slotProps.data.id : "" }}
        </template>
      </Column>
      <Column field="oppStatusCode" header="Display Order" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.oppStatusCode ? slotProps.data.oppStatusCode : "" }}
        </template>
      </Column>
      <Column field="colourCode" header="Colour Code" :sortable="true">
        <template #body="slotProps">
          {{
            slotProps.data.colourCode && slotProps.data.colourCode.label
              ? slotProps.data.colourCode.label
              : ""
          }}
        </template>
      </Column>
      <Column field="oppStatusName" header="Status Desc" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.oppStatusName ? slotProps.data.oppStatusName : "" }}
        </template>
      </Column>
      <Column field="active" header="Active" :sortable="true">
        <template #body="slotProps">
          <span v-if="slotProps.data.active">YES</span>
          <span v-else>NO</span>
        </template>
      </Column>
      <Column headerStyle="width: 10em;">
        <template #body="slotProps">
          <div :style="{ position: 'relative' }">
            <SplitButton
              label="Edit"
              icon="pi pi-pencil"
              class="p-button-success p-mb-2"
              @click="editopportunityStatuses(slotProps.data)"
              :model="getButtons(slotProps.data)"
            >
            </SplitButton>
          </div>
        </template>
      </Column>
    </DataTable>
    <Dialog
      :visible.sync="opportunityStatusesForm"
      :style="{ width: '640px', overflowY: 'auto' }"
      header="Industry Type"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="noteHeader">Display Order:</label>
          <InputText
            id="noteHeader"
            v-model.trim="opportunityStatus.oppStatusCode"
            required="true"
            autofocus
          />
        </div>
        <div class="p-field p-col">
          <label for="noteDetails">Color Code:</label>
          <Dropdown
            :showClear="true"
            v-model="opportunityStatus.colourCode"
            :options="colourCodes"
            optionLabel="label"
            dataKey="value"
            placeholder="Select Color Code"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="noteDetails">Status Desc:</label>
          <InputText
            placeholder=""
            :disabled="false"
            :autoResize="true"
            rows="6"
            v-model="opportunityStatus.oppStatusName"
          />
        </div>
        <div class="p-field p-col">
          <label for="noteDetails">Active:</label>
          <SelectButton
            v-model="opportunityStatus.active"
            :options="options"
            optionLabel="label"
            optionValue="value"
          />
        </div>
      </div>
      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-text"
          @click="opportunityStatusesForm = false"
        />
        <Button
          label="Save"
          icon="pi pi-check"
          class="p-button-text"
          @click="save"
        />
      </template>
    </Dialog>
    <Dialog
      header="Confirmation"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px', overflowY: 'auto' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span>Do you wish to delete the Opportunity Statuses?</span>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="closeConfirmation"
          class="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          @click="deleteopportunityStatus"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import OpportunityService from "@/service/OpportunityService";
import PermissionMixin from "../PermissionMixin.vue";
export default {
  mixins: [PermissionMixin],
  opportunityService: null,
  data: () => ({
    opportunityStatusesForm: false,
    displayConfirmation: false,
    filters: {},
    opportunityStatuses: null,
    opportunityStatus: {},
    options: [
      { value: true, label: "yes" },
      { value: false, label: "no" }
    ],
    colourCodes: [
      { label: "Blue", value: "badge-primary" },
      { label: "Sky Blue", value: "badge-info" },
      { label: "Gray", value: "badge-secondary" },
      { label: "Green", value: "badge-success" },
      { label: "Red", value: "badge-danger" },
      { label: "Orange", value: "badge-warning" },
      { label: "White", value: "badge-light" },
      { label: "Black", value: "badge-dark" }
    ],
    requesting: false
  }),
  created() {
    this.opportunityService = new OpportunityService();
  },
  mounted() {
    this.getAllOpportunityStatuses();
  },
  computed: {
    loading() {
      if (this.opportunityStatuses && this.opportunityStatuses[0]) {
        return false;
      } else {
        if (this.requesting) {
          return true;
        } else {
          return false;
        }
      }
    }
  },
  methods: {
    getButtons(data) {
      this.checkPermissions();
      let buttons = [];
      if (this.deleteSettings) {
        buttons.push({
          label: "Delete",
          icon: "pi pi-trash",
          command: () => {
            this.openConfirmation(data);
          }
        });
      }
      return buttons;
    },
    async getAllOpportunityStatuses() {
      this.requesting = true;
      this.opportunityStatuses = await this.opportunityService.getAllOpportunityStatusesByHard();
      this.requesting = false;
      this.opportunityStatuses.forEach(element => {
        if (element.colourCode)
          element.colourCode = this.colourCodes.find(
            code => code.value === element.colourCode
          );
      });
    },
    async getAllActiveOpportunityStatusesByHard() {
      await this.opportunityService.getAllActiveOpportunityStatusesByHard();
    },
    openNewTypesForm() {
      this.opportunityStatus = {};
      this.opportunityStatusesForm = true;
    },
    openConfirmation(data) {
      this.opportunityStatus = data;
      this.displayConfirmation = true;
    },
    closeConfirmation() {
      this.displayConfirmation = false;
    },
    editopportunityStatuses(data) {
      this.opportunityStatus = data;
      this.opportunityStatusesForm = true;
    },
    async deleteopportunityStatus() {
      this.closeConfirmation();
      await this.customerService.deleteOpportunityStatuses(
        this.opportunityStatus.id
      );
      this.$toast.add({
        severity: "success",
        summary: "Success Message",
        detail: "Enquiry Status removed",
        life: 5000
      });
    },
    save() {
      if (
        this.opportunityStatus.colourCode &&
        this.opportunityStatus.colourCode.value
      )
        this.opportunityStatus.colourCode = this.opportunityStatus.colourCode.value;

      if (!this.opportunityStatus.id) {
        this.opportunityService
          .postOpportunityStatuses(this.opportunityStatus)
          .then(res => {
            this.$toast.add({
              severity: "success",
              summary: "Success Message",
              detail: "Enquiry Status added",
              life: 5000
            });
            this.getAllOpportunityStatuses();
            this.getAllActiveOpportunityStatusesByHard();
          })
          .catch(err => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving Enquiry status",
              life: 5000
            });
          });
      } else {
        this.opportunityService
          .putOpportunityStatuses(
            this.opportunityStatus,
            this.opportunityStatus.id
          )
          .then(res => {
            this.$toast.add({
              severity: "success",
              summary: "Success Message",
              detail: "Enquiry Status updated",
              life: 5000
            });
            this.getAllOpportunityStatuses();
            this.getAllActiveOpportunityStatusesByHard();
          })
          .catch(err => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating Enquiry status",
              life: 5000
            });
          });
      }
      this.opportunityStatusesForm = false;
    }
  }
};
</script>
